// Shared by the app preview and the PDF Lambda so both render terms identically.
const TERM_BODY_STYLE = `<style>
.term-body{font-size:calc(14px*var(--doc-scale));line-height:var(--doc-lh)}
.term-body h1{font-weight:700;font-size:calc(20px*var(--doc-scale))}
.term-body h2{font-weight:600}
.term-body ul{list-style:disc;padding-left:24px}
.term-body ol{list-style:decimal;padding-left:24px;margin:.35em 0}
.term-body li{margin:.1em 0}
.term-body blockquote{margin:.35em 0;border-left:2px solid #d4d4d8;padding-left:12px}
</style>`;

export function renderTermBody(renderedContent: string | null | undefined): string {
  if (!renderedContent) return "";
  return `${TERM_BODY_STYLE}<section data-zone="body" class="term-body">${renderedContent}</section>`;
}
